/**
 * Widget "Souvent achetés ensemble" (fiche produit) : recalcule le total
 * en direct selon les cases cochées, puis ajoute la sélection au panier
 * via l'API Cart AJAX de Shopify (/cart/add.js) et recharge la page pour
 * que le panier (icône, tiroir, etc.) reflète immédiatement l'ajout.
 */

/**
 * Reproduit le filtre Liquid `money` côté client, à partir du gabarit
 * `shop.money_format` (ex. "{{amount}}€", "${{amount_with_comma_separator}}").
 * @param {number} cents
 * @param {string} format
 */
function formatMoney(cents, format) {
  const amount = (cents / 100).toFixed(2);
  const [whole, decimals] = amount.split('.');
  const withDot = `${whole}.${decimals}`;
  const withComma = `${whole},${decimals}`;
  const noDecimals = whole;

  if (!format) return `${withComma}€`;

  return format
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
    .replace(/\{\{\s*amount\s*\}\}/g, withDot);
}

document.querySelectorAll('.bought-together').forEach((widget) => {
  const format = widget.dataset.moneyFormat;
  const totalEl = widget.querySelector('[data-bought-together-total]');
  const addButton = widget.querySelector('[data-bought-together-add]');
  const checkboxes = widget.querySelectorAll('.bought-together__check');

  function updateTotal() {
    if (!totalEl) return;
    const base = parseInt(totalEl.dataset.basePrice, 10) || 0;
    let total = base;
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        total += parseInt(checkbox.dataset.price, 10) || 0;
      }
    });
    totalEl.textContent = formatMoney(total, format);
  }

  updateTotal();

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', updateTotal);
  });

  addButton?.addEventListener('click', async () => {
    const items = [{ id: parseInt(addButton.dataset.mainVariantId, 10), quantity: 1 }];
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        items.push({ id: parseInt(checkbox.dataset.variantId, 10), quantity: 1 });
      }
    });

    const originalText = addButton.textContent;
    addButton.disabled = true;
    addButton.textContent = 'Ajout en cours…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) throw new Error('cart add failed');

      addButton.textContent = 'Ajouté ✓';
      window.location.reload();
    } catch (error) {
      addButton.disabled = false;
      addButton.textContent = originalText;
      // eslint-disable-next-line no-console
      console.error('[bought-together] add to cart failed', error);
    }
  });
});
